<style scoped></style>

<template>
  <div>
    <VueMarkdown
      class="mt-1 max-w-2xl text-sm leading-5 prose max-w-none"
      :source="this.introduction"
    />
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render';

export default {
  name: 'IntroductionComponent',
  components: {
    VueMarkdown,
  },
  props: {
    form_id: String,
    introduction: String,
    code: String,
  },
};
</script>
